export default __webpack_public_path__ + "static/JoséphineAdeshina-a04bb2dacd9cb6aa1cd55ba115e3f1c4.png";